import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from 'app/shared/services/account/account.service'
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageConstant } from 'app/shared/utils/message.constant';
import { Router } from '@angular/router';
@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class RegisterComponent implements OnInit, OnDestroy {
  registerForm: FormGroup;
  isPasswordFieldType: boolean;
  isPasswordConfirmFieldType: boolean;
  logs: any;
  validateOTP: boolean = false;
  hideDetail: boolean = true;
  // Private
  isErrorMessage = false;
  errorMessage = "";
  isSuccessMessage = false;
  successMessage = "";
  private _unsubscribeAll: Subject<any>;

  constructor(private accountService: AccountService, private router: Router,
    private _fuseConfigService: FuseConfigService, private snackBar: MatSnackBar,
    private _formBuilder: FormBuilder
  ) {
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.registerForm = this._formBuilder.group({
      f_name: ['', [Validators.required]],
      m_name: ['', [Validators.required]],
      l_name: ['', [Validators.required]],
      username: ['', [Validators.required]],
      email: ['', [Validators.required]],
      MobNo: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      u_altmobile: ['',],
      password: ['', [Validators.required]],
      confirmPassword: ['', [this.confirmValidator]],
      otp: [''],
    });

    // Update the validity of the 'passwordConfirm' field
    // when the 'password' field changes
    // this.registerForm.get('password').valueChanges
    //     .pipe(takeUntil(this._unsubscribeAll))
    //     .subscribe(() => {
    //         this.registerForm.get('passwordConfirm').updateValueAndValidity();
    //     });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.registerForm.controls.password.value) {
      return { error: true, confirm: true };
    }
  }

  togglePasswordFieldType() {
    this.isPasswordFieldType = !this.isPasswordFieldType;
  }

  togglePasswordConfirmFieldType() {
    this.isPasswordConfirmFieldType = !this.isPasswordConfirmFieldType;
  }

  public resolved(captchaResponse: string) {
  }

  register() {
    let formValues = this.registerForm.value;

    let params = {

      username: formValues.username,
      password: formValues.confirmPassword,
      mobile: formValues.MobNo,
      alt_mobile: "1234567890",
      email: formValues.email,
      device_id: "qwertyuiop",
      app_version: "9876543wsdfghnm",
      os_version: "10",
      f_name: formValues.f_name,
      m_name: formValues.m_name,
      l_name: formValues.l_name,
      client_id: 1,
      dob: "",
      user_type: "END",
      can_expire: "Y",
      is_verified: "N",
      registration_origin: "WEB",
      status: "Y",
      created_by: 1,
      // otp_purpose : "REGISTER" 

    }
    //
    this.accountService.register(params).subscribe((res: any) => {
      //
      this.logs = res;
      if (res.status) {
        this.successMessage = MessageConstant.userOTPSend;
        this.isSuccessMessage = true;
        setTimeout(() => {                           //<<<---using ()=> syntax
          this.isSuccessMessage = false;
        }, 3000);
        //this.snackBar.open(MessageConstant.userOTPSend, 'Dismiss', { duration: 3000 });
        this.hideDetail = false;
        this.validateOTP = true;
      } else {
        this.errorMessage = MessageConstant.dublicateRegistrationMessage;
        this.isErrorMessage = true;
        setTimeout(() => {                           //<<<---using ()=> syntax
          this.isErrorMessage = false;
        }, 3000);
        //this.snackBar.open(MessageConstant.dublicateRegistrationMessage, 'Dismiss', { duration: 3000 });
      }

    }, (err) => {
      this.errorMessage = MessageConstant.errorMessage;
      this.isErrorMessage = true;
      setTimeout(() => {                           //<<<---using ()=> syntax
        this.isErrorMessage = false;
      }, 3000);
      //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
      this.router.navigateByUrl('/register');
    })
  }
  vaidateOTP() {
    let formValues = this.registerForm.value;
    let params = {
      username: formValues.username,
      mobile: formValues.MobNo,
      email: formValues.email,
      otp: formValues.otp

    }
    this.accountService.verifyUserNew(params).subscribe((res: any) => {
      this.logs = res;
      this.router.navigateByUrl('/login');
      this.successMessage = MessageConstant.userRegisterdMessage;
      this.isSuccessMessage = true;
      setTimeout(() => {                           //<<<---using ()=> syntax
        this.isSuccessMessage = false;
      }, 3000);
      //this.snackBar.open(MessageConstant.userRegisterdMessage, 'Dismiss', { duration: 3000 });
    }, (err) => {
      this.errorMessage = MessageConstant.errorMessage;
      this.isErrorMessage = true;
      setTimeout(() => {                           //<<<---using ()=> syntax
        this.isErrorMessage = false;
      }, 3000);
      //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
      this.router.navigateByUrl('/register');
    })
  }
  resendOTP() {
    let formValues = this.registerForm.value;
    let params = {
      mobile: formValues.MobNo,
      email: formValues.email,
      username: formValues.username,
      id: null,
      otp_purpose: "REGISTER"
    }
    this.accountService.getotpNew(params).subscribe((res: any) => {
      this.logs = res;
      this.successMessage = MessageConstant.getOTPMessage;
      this.isSuccessMessage = true;
      setTimeout(() => {                           //<<<---using ()=> syntax
        this.isSuccessMessage = false;
      }, 3000);
      //this.snackBar.open(MessageConstant.getOTPMessage, 'Dismiss', { duration: 3000 });
    }, (err) => {
      this.errorMessage = MessageConstant.errorMessage;
      this.isErrorMessage = true;
      setTimeout(() => {                           //<<<---using ()=> syntax
        this.isErrorMessage = false;
      }, 3000);
      //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
      this.router.navigateByUrl('/register');
    })
  }
}

// /**
//  * Confirm password validator
//  *
//  * @param {AbstractControl} control
//  * @returns {ValidationErrors | null}
//  */
// export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

//     if ( !control.parent || !control )
//     {
//         return null;
//     }

//     const password = control.parent.get('password');
//     const passwordConfirm = control.parent.get('passwordConfirm');

//     if ( !password || !passwordConfirm )
//     {
//         return null;
//     }

//     if ( passwordConfirm.value === '' )
//     {
//         return null;
//     }

//     if ( password.value === passwordConfirm.value )
//     {
//         return null;
//     }

//     return {passwordsNotMatching: true};
// };
